import { createSelector } from 'reselect';
export const passLabel = (state, label) => label;
export const EMPTY_ARRAY = [];
export const selectRawContracts = state => state.contracts;
export const selectContracts = createSelector([selectRawContracts, passLabel], (rawContracts, label = '') => rawContracts[label] || EMPTY_ARRAY);